"use client";
import { Fragment } from "react";
import { PiArrowRight } from "react-icons/pi";
import classNames from "classnames";
import { Nullable } from "@/types";
import { Button } from "@cappelendamm/design-system/react";
import { setCookie } from "@cappelendamm/cookie";
import { COOKIE_UNIVERSE } from "@/routing";
import { useRouter } from "next/navigation";

export type Universe = Nullable<{
  tag: string;
  title: string;
}>;

type UniverseSelectProps = {
  universes: Universe[];
  className?: string;
};

export function UniverseSelect({ universes, className }: UniverseSelectProps) {
  const { replace } = useRouter();
  return (
    <div className={classNames("grid gap-2", className)}>
      {universes.map((universe) => (
        <Fragment key={universe.tag}>
          <Button
            onClick={() => {
              setCookie({ name: COOKIE_UNIVERSE, value: universe.tag ?? "" });
              replace("/");
            }}
            className="justify-start"
            variant="secondary-small"
          >
            {universe.title}
            <PiArrowRight />
          </Button>
        </Fragment>
      ))}
    </div>
  );
}
